import { useEffect } from 'react'
import useMobileDetect from 'app/hooks/use-mobile-detect.hook'

/** This hook is used for ios safari compatibility
 * See https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ */

export default function useMobileVh() {
  const deviceType = useMobileDetect()

  useEffect(() => {
    function setDocHeight() {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight / 100}px`
      )
    }

    if (deviceType.isMobile()) {
      setTimeout(() => setDocHeight(), 200)

      window.addEventListener('resize', () => {
        setDocHeight()
      })
      window.addEventListener('orientationchange', () => {
        setDocHeight()
      })
    }

    return () => {
      window.removeEventListener('resize', () => {
        setDocHeight()
      })
      window.removeEventListener('orientationchange', () => {
        setDocHeight()
      })
    }
  }, [deviceType])
}
